import type { User } from 'shared-types';

import type { LocaleMessages, ServerConfig } from 'shared-types';

type Params = {
  messages: LocaleMessages;
  serverConfig: ServerConfig<'guest'>;
  user: Pick<User, 'id' | 'firstName' | 'lastName' | 'username'> &
    Partial<Pick<User, 'roles'>>;
};

const getUserDisplayName = ({ messages, serverConfig, user }: Params) => {
  if (!serverConfig || !user) return '';

  if (
    ((!user.roles?.includes('guest') && serverConfig.userUseName) ||
      (user.roles?.includes('guest') && serverConfig.accountGuestUseName)) &&
    user.firstName &&
    user.lastName
  ) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user.roles?.includes('guest')) {
    return `${messages.usersGuest}${user.id}`;
  }

  return user.username;
};

export default getUserDisplayName;
